// extracted by mini-css-extract-plugin
module.exports = {"container":"ThankYou_container__ZvIAg","message_container":"ThankYou_message_container__vTPh_","title":"ThankYou_title__gfK89"};